import { CSSProperties } from "react";
import styles from "./styles.module.scss";

import StyledIcon from "@generic-components/StyledIcon";

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  btnText: string;
  id: string;
  name: string;
  style?: CSSProperties;
  errorMsg?: string;
  icon?: string;
  iconStyle?: CSSProperties | string;
  iconColor?: string;
  onClick?: () => void;
  btnStyle?: string;
  disabled?: boolean;
}

const Button: React.FC<ButtonProps> = ({
  id,
  icon,
  name,
  style,
  btnText,
  errorMsg,
  iconStyle,
  className,
  iconColor = "",
  btnStyle = "",
  onClick = () => {},
  disabled = false,
  ...props
}) => {
  return (
    <div
      className={`${className} ${styles.buttonWrapper} ${
        disabled ? styles.disabled : "cursor-pointer"
      }`}
      onClick={() => {
        if (!disabled) {
          onClick();
        }
      }}
      style={style}
    >
      <button
        id={id}
        name={name}
        className={`${styles.btnCss} ${btnStyle}`}
        disabled={disabled}
        {...props}
      >
        {icon && (
          <span className={`${iconStyle}`}>
            <StyledIcon icon={icon} inline={true} color={iconColor} />
          </span>
        )}
        {btnText}
      </button>
      {errorMsg && <div className={styles.errMsg}>{errorMsg}</div>}
    </div>
  );
};

export default Button;
